export default __webpack_public_path__ + "static/media/98.8d235b41.png";